import { NgModule } from '@angular/core';
import { isString, trim, isObject, isArray, cloneDeep, isEmpty, camelCase, isError, get, set } from 'lodash';
import { SharedConstants } from '@formbird/types';
import { __awaiter } from 'tslib';
import { createPatch, applyPatch } from 'rfc6902';
import { each, eachSeries } from 'async';
import { v1 } from 'uuid';
import { compile } from 'handlebars';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/formbird-shared.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormbirdSharedModule {
}
FormbirdSharedModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/SharedUrlRoutes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const restBasePath = 'api/';
/** @type {?} */
const serverRoutes = (/** @type {?} */ ({}));
serverRoutes.appHome = '/';
serverRoutes.appLogin = '/';
serverRoutes.appForgotPass = 'forgotpass';
serverRoutes.appForgotPassAction = 'auth/forgotpass';
serverRoutes.appResetPass = 'resetpass';
serverRoutes.appResetpassAction = 'auth/resetpass';
serverRoutes.appActivateAccount = 'activateAccount';
serverRoutes.appActivateAccountAction = 'auth/activateAccount';
serverRoutes.appDefault = 'default';
serverRoutes.logout = 'auth/logout';
serverRoutes.logoutAllDevices = 'auth/logoutAllDevices';
serverRoutes.login = 'auth/login/local';
serverRoutes.loginSaml = 'auth/login/saml';
serverRoutes.loginGoogle = 'auth/login/google';
serverRoutes.loginGoogleCallback = 'auth/login/google/callback';
serverRoutes.loginFacebook = 'auth/login/facebook';
serverRoutes.loginFacebookCallback = 'auth/login/facebook/callback';
serverRoutes.loggedUser = 'api/loggedUser';
serverRoutes.loggedUserData = 'api/loggedUserData';
serverRoutes.loggedUserAccountControlDocument = serverRoutes.loggedUser + '/accountControlDocument';
serverRoutes.loggedUserAccountGroupConfigDocument = serverRoutes.loggedUser + '/accountGroupConfigDocument';
serverRoutes.testPassword = 'password/test';
serverRoutes.publicLogin = '/auth/login/public';
serverRoutes.uploadFiles = restBasePath + 'uploadFiles';
serverRoutes.deleteFile = restBasePath + 'deleteFile';
serverRoutes.loadFile = restBasePath + 'getFile';
serverRoutes.getFile = restBasePath + 'getFile/:fileNo';
serverRoutes.getFileWithName = restBasePath + 'getFile/:fileNo/:fileName';
serverRoutes.viewReport = restBasePath + 'viewReport';
serverRoutes.packageImport = restBasePath + "uploadPackage";
serverRoutes.packageExport = restBasePath + "packageExport/:id";
serverRoutes.packageCleanUp = restBasePath + "packageCleanUp/:type/:id";
// Template and Document routes
serverRoutes.document = restBasePath + 'document';
// userId parameter will be ignored because the logged in user will always be used
serverRoutes.documentWithUser = restBasePath + 'document/:userId';
serverRoutes.documentWithUserBase = restBasePath + 'documentWithUser';
serverRoutes.documentDeepDiffUpdate = serverRoutes.document + '/deepDiffUpdate';
serverRoutes.documentDeepDiffUpdateSingle = serverRoutes.documentDeepDiffUpdate + '/:id';
serverRoutes.documentExists = serverRoutes.document + '/exists';
serverRoutes.documentExistsFull = serverRoutes.documentExists + '/:id';
serverRoutes.documentExistsIncludeDeleted = serverRoutes.documentExists + "/:id/:includeDeleted";
serverRoutes.documentSingle = serverRoutes.document + '/:id';
// userId parameter will be ignored because the logged in user will always be used
serverRoutes.documentSingleWithUser = serverRoutes.documentWithUserBase + '/:id/:userId';
serverRoutes.documentDestroy = serverRoutes.document + '/:id';
serverRoutes.documentDestroyWithTemplateIdAndPreviousVersionId = serverRoutes.document + '/:id/:templateId/:previousVersionId';
serverRoutes.documentSingleOverrideTpl = serverRoutes.documentDeepDiffUpdate + '/:id/:template';
serverRoutes.documentDeepDiffUpdateWithUser = serverRoutes.document + '/deepDiffUpdateWithUser';
// userId parameter will be ignored because the logged in user will always be used
serverRoutes.documentDeepDiffUpdateSingleWithUser = serverRoutes.documentDeepDiffUpdateWithUser + '/:id/:userId';
serverRoutes.syncDocuments = restBasePath + 'syncDocuments';
serverRoutes.syncRecordsByServerUpdatedDateWithPagination = serverRoutes.syncDocuments + '/:startTime/:pageNumber';
serverRoutes.syncDocumentsCountURL = restBasePath + 'syncDocumentsCount';
serverRoutes.syncDocumentsCountByDateRoute = serverRoutes.syncDocumentsCountURL + '/:startTime';
serverRoutes.undeleteDocument = restBasePath + 'undelete' + '/:id';
serverRoutes.bulkUploadDocuments = restBasePath + "bulkUploadDocuments";
// document audit
serverRoutes.documentAudit = restBasePath + 'documentAudit';
// index.html. This is written dynamically so that the base path can be changed
serverRoutes.indexHtml = '/index.html';
serverRoutes.documentSearch = restBasePath + 'documentSearch';
// find documents directly in Mongo
serverRoutes.documentFind = restBasePath + 'documentFind' + '/:query';
serverRoutes.documentsBaseUrl = restBasePath + 'documents';
serverRoutes.documentsUrl = serverRoutes.documentsBaseUrl + '/:query';
serverRoutes.documentFetch = restBasePath + 'documentFetch';
serverRoutes.versionFetch = restBasePath + "versionFetch";
/**
 * Could not retrieve docs from client side URL query
 */
serverRoutes.loadDocsForRulesBaseUrl = restBasePath + 'documents/loadDocsForRules';
// userId parameter will be ignored because the logged in user will always be used
serverRoutes.loadDocsForRulesUrl = serverRoutes.loadDocsForRulesBaseUrl + '/:userId';
serverRoutes.loadIncludeDocs = restBasePath + 'loadIncludeDocs';
serverRoutes.template = restBasePath + 'template';
serverRoutes.templateSingle = serverRoutes.template + '/:id';
serverRoutes.sessionTest = restBasePath + 'sessionTest';
serverRoutes.serverTime = restBasePath + 'time/current';
// custom component functions
serverRoutes.executeFunction = restBasePath + 'execute';
serverRoutes.loadComponentDoc = restBasePath + 'loadComponentDoc/:componentName';
serverRoutes.loadComponent = restBasePath + 'loadComponent/:componentName';
serverRoutes.loadComponentLibrary = restBasePath + 'loadComponentLibraryFunctions';
serverRoutes.loadComponentLibraryFunctions = serverRoutes.loadComponentLibrary + '/:serviceName';
serverRoutes.loadVendorLibrary = restBasePath + 'loadVendorLibrary/:name'; // name or documentId
// name or documentId
serverRoutes.loadVendorLibraries = restBasePath + 'loadVendorLibraries';
// urls for loading configuration from database
serverRoutes.loadClientConfig = 'clientConfig';
serverRoutes.clientResources = restBasePath + 'clientResources';
/** @type {?} */
const SharedUrlRoutes = {
    REST_API_WEB_BASE_PATH: restBasePath,
    serverRoutes: serverRoutes
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/access/AccessManager.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AccessManager {
    /**
     * @private
     * @param {?} keyId
     * @return {?}
     */
    static filterNullKeyIds(keyId) {
        return isString(keyId) && trim(keyId) && keyId !== 'undefined';
    }
    /**
     * @private
     * @param {?} accessKey
     * @return {?}
     */
    static filterObjectOnlyAccessKeys(accessKey) {
        return isObject(accessKey);
    }
    /**
     * @param {?} userAccountControlDocument
     * @param {?} operation
     * @return {?}
     */
    static getUserAccessKeysForOperation(userAccountControlDocument, operation) {
        /** @type {?} */
        const userAccessKeysForOperation = [];
        // See issue 12125 for more info about Account Control Documents
        /** @type {?} */
        let userAccessKeys = userAccountControlDocument ? userAccountControlDocument.accessKeys : null;
        if (userAccessKeys) {
            userAccessKeys = userAccessKeys.filter(AccessManager.filterObjectOnlyAccessKeys);
            for (let x = 0; x < userAccessKeys.length; x++) {
                /** @type {?} */
                const userAccessKey = userAccessKeys[x];
                /** @type {?} */
                const key = userAccessKey.keyId ? userAccessKey.keyId : userAccessKey.documentId;
                if (key && userAccessKey.rights && userAccessKey.rights.indexOf(operation) > -1) {
                    userAccessKeysForOperation.push(key);
                }
            }
        }
        return userAccessKeysForOperation;
    }
    // Retains the old behavior of 'hasPermission'; Returns true if user is allowed to perform at least 1 operation.
    /**
     * @private
     * @param {?} targetDocument
     * @param {?} userAccountControlDocument
     * @param {?} operations
     * @param {?=} noTemplateAccessKeys
     * @return {?}
     */
    static checkPermission(targetDocument, userAccountControlDocument, operations, noTemplateAccessKeys) {
        /** @type {?} */
        const noTemplateAccessKeyIds = noTemplateAccessKeys ? noTemplateAccessKeys : [];
        /** @type {?} */
        let documentKeyIds = targetDocument && targetDocument.systemHeader
            && targetDocument.systemHeader.keyIds ? targetDocument.systemHeader.keyIds : noTemplateAccessKeyIds;
        documentKeyIds = documentKeyIds.filter(AccessManager.filterNullKeyIds);
        for (let j = 0; j < operations.length; j++) {
            /** @type {?} */
            const operation = operations[j];
            // Documents without keys are unrestricted during non-offline operations.
            if ((!documentKeyIds || documentKeyIds.length === 0) && operation !== SharedConstants.OPERATION_TYPE_OFFLINE) {
                return true;
            }
            /** @type {?} */
            const userAccessKeysForOperation = AccessManager.getUserAccessKeysForOperation(userAccountControlDocument, operation);
            for (let i = 0; i < userAccessKeysForOperation.length; i++) {
                if (documentKeyIds && documentKeyIds.indexOf(userAccessKeysForOperation[i]) > -1) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * @param {?} targetDocument
     * @param {?} userAccountControlDocument
     * @param {?} operation
     * @param {?=} noTemplateAccessKeys
     * @return {?}
     */
    static checkAccess(targetDocument, userAccountControlDocument, operation, noTemplateAccessKeys) {
        if (isArray(operation)) {
            return AccessManager.checkPermission(targetDocument, userAccountControlDocument, operation, noTemplateAccessKeys);
        }
        return AccessManager.checkPermission(targetDocument, userAccountControlDocument, [operation], noTemplateAccessKeys);
    }
    /**
     * @param {?} document
     * @param {?} template
     * @param {?} userAccountControlDocument
     * @param {?=} defaultAttachKeys
     * @return {?}
     */
    static writeKeysToDocument(document, template, userAccountControlDocument, defaultAttachKeys) {
        // Prepare systemHeader and keyIds
        document.systemHeader = document.systemHeader ? document.systemHeader : {};
        document.systemHeader.keyIds = document.systemHeader.keyIds ? document.systemHeader.keyIds : [];
        /** @type {?} */
        let attachKeys = [].concat(document.systemHeader.keyIds);
        if (template && template.attachKeys && template.attachKeys.length) {
            attachKeys = attachKeys.concat(template.attachKeys);
        }
        attachKeys = attachKeys.concat(userAccountControlDocument.attachKeys);
        if (defaultAttachKeys && defaultAttachKeys.length) {
            attachKeys = attachKeys.concat(defaultAttachKeys);
        }
        document.systemHeader.keyIds = Array.from(new Set(attachKeys));
        document.systemHeader.keyIds = document.systemHeader.keyIds.filter(AccessManager.filterNullKeyIds);
    }
    /**
     * @param {?} targetDocument
     * @param {?} userAccountControlDocument
     * @param {?} operations
     * @return {?}
     */
    static hasPermission(targetDocument, userAccountControlDocument, operations) {
        /** @type {?} */
        const operationArr = operations.split(',');
        return AccessManager.checkPermission(targetDocument, userAccountControlDocument, operationArr);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/ErrorCodes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErrorCodes {
}
ErrorCodes.ERROR_NO_ACCOUNT_TEMPLATE = '1000';
ErrorCodes.ERROR_NO_ACCOUNT_SECURITY_TEMPLATE = '1001';
ErrorCodes.ERROR_NO_ACCOUNT_CONTROL_TEMPLATE = '1002';
ErrorCodes.ERROR_DUPLICATE_ACCOUNT_EMAIL = '1003';
ErrorCodes.ERROR_DUPLICATE_ACCOUNT_PUBLIC_URL = '1004';
ErrorCodes.ERROR_DUPLICATE_ACCOUNT_API_KEY = '1005';
ErrorCodes.ERROR_UPLOAD_DIR_DOES_NOT_EXIST = '1006';
ErrorCodes.ERROR_ORPHANED_ACCOUNT_API_KEY = '1007';
ErrorCodes.ERROR_ORPHANED_ACCOUNT_PUBLIC_URL = '1008';
ErrorCodes.ERROR_NOT_FOUND_ACCOUNT_API_KEY = '1009';
ErrorCodes.ERROR_NOT_FOUND_ACCOUNT_PUBLIC_URL = '1010';
ErrorCodes.ERROR_PASSWORD_RESET_REQUIRED = "1011";
if (false) {
    /** @type {?} */
    ErrorCodes.ERROR_NO_ACCOUNT_TEMPLATE;
    /** @type {?} */
    ErrorCodes.ERROR_NO_ACCOUNT_SECURITY_TEMPLATE;
    /** @type {?} */
    ErrorCodes.ERROR_NO_ACCOUNT_CONTROL_TEMPLATE;
    /** @type {?} */
    ErrorCodes.ERROR_DUPLICATE_ACCOUNT_EMAIL;
    /** @type {?} */
    ErrorCodes.ERROR_DUPLICATE_ACCOUNT_PUBLIC_URL;
    /** @type {?} */
    ErrorCodes.ERROR_DUPLICATE_ACCOUNT_API_KEY;
    /** @type {?} */
    ErrorCodes.ERROR_UPLOAD_DIR_DOES_NOT_EXIST;
    /** @type {?} */
    ErrorCodes.ERROR_ORPHANED_ACCOUNT_API_KEY;
    /** @type {?} */
    ErrorCodes.ERROR_ORPHANED_ACCOUNT_PUBLIC_URL;
    /** @type {?} */
    ErrorCodes.ERROR_NOT_FOUND_ACCOUNT_API_KEY;
    /** @type {?} */
    ErrorCodes.ERROR_NOT_FOUND_ACCOUNT_PUBLIC_URL;
    /** @type {?} */
    ErrorCodes.ERROR_PASSWORD_RESET_REQUIRED;
}
;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/SystemHeaderFilter.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// fields to remove from systemHeader. Each field in the array will be removed
/** @type {?} */
const fieldsToExclude = [
    'serverCreatedDate',
    'serverUpdatedDate',
    'previousVersionId'
];
class SystemHeaderFilter {
    /**
     * remove any values from systemHeader that shouldn't be updated, as specified in
     * Mantis 10975: Do not overwrite values in systemHeader that aren't included in update
     * @param {?} document the document
     * @return {?}
     */
    static filterSystemHeader(document) {
        if (document.systemHeader) {
            for (let i = 0; i < fieldsToExclude.length; i++) {
                delete document.systemHeader[fieldsToExclude[i]];
            }
        }
    }
    /**
     * When update or jsonPatchUpdate functions are called, only those values in
     * the update that are passed in as part of the systemHeader should be updated. Other values in
     * the systemHeader should not be removed or changed
     * Mantis 10975: Do not overwrite values in systemHeader that aren't included in update
     * @param {?} origDoc
     * @param {?} newDoc
     * @return {?}
     */
    static applyUpdatesToSystemHeader(origDoc, newDoc) {
        if (newDoc.systemHeader) {
            SystemHeaderFilter.filterSystemHeader(origDoc);
            SystemHeaderFilter.filterSystemHeader(newDoc);
            /** @type {?} */
            const updateKeys = Object.keys(newDoc.systemHeader);
            if (!origDoc.systemHeader) {
                origDoc.systemHeader = {};
            }
            for (let i = 0; i < updateKeys.length; i++) {
                /** @type {?} */
                const fieldName = updateKeys[i];
                /** @type {?} */
                const value = newDoc.systemHeader[fieldName];
                if (fieldName !== 'currentVersion') {
                    origDoc.systemHeader[fieldName] = value;
                }
            }
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/DocumentUpdater.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger = console;
// let jsonPatch;
class DocumentUpdater {
    /**
     * do any functions that are specific to a system type like clearing the document from the cache
     * @private
     * @param {?} document the document
     * @param {?} updateDoc the updateDoc
     * @return {?}
     */
    static performSystemTypeUpdateOperations(document, updateDoc) {
        if (document.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_ACCOUNT && !updateDoc.pass) {
            updateDoc.pass = document.pass;
        }
    }
    /**
     * simple update - non deep
     * @param {?} document the document
     * @param {?} updateDoc the updateDoc
     * @return {?}
     */
    static applyUpdatesSimple(document, updateDoc) {
        if (updateDoc) {
            // perform any operations specific to a systemType
            DocumentUpdater.performSystemTypeUpdateOperations(document, updateDoc);
            // set the values in the updateDoc in the existing currentDocument
            /** @type {?} */
            const updateKeys = Object.keys(updateDoc);
            for (let i = 0; i < updateKeys.length; i++) {
                /** @type {?} */
                const fieldName = updateKeys[i];
                if (fieldName === 'systemHeader') {
                    SystemHeaderFilter.applyUpdatesToSystemHeader(document, updateDoc);
                }
                else {
                    document[fieldName] = updateDoc[fieldName];
                }
            }
        }
    }
    // get the updates by comparing the doc and original doc
    /**
     * @param {?} originalDoc
     * @param {?} doc
     * @return {?}
     */
    static getUpdates(originalDoc, doc) {
        return __awaiter(this, void 0, void 0, function* () {
            logger.info('Determining fields that have changed in update');
            // jsonPatch = await AsyncLibLoader.loadJsonPatch();
            /** @type {?} */
            const changes = originalDoc ? createPatch(originalDoc, doc) : [];
            return {
                updates: changes,
                documentId: doc.documentId
            };
        });
    }
    /**
     * @param {?} document
     * @param {?} updateData
     * @return {?}
     */
    static applyUpdates(document, updateData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (updateData.updates) {
                // jsonPatch = await AsyncLibLoader.loadJsonPatch();
                applyPatch(document, updateData.updates);
            }
        });
    }
    /**
     * @param {?} document
     * @param {?} updateDoc
     * @return {?}
     */
    static applyUpdatesDeepDiff(document, updateDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            SystemHeaderFilter.applyUpdatesToSystemHeader(document, updateDoc);
            if (updateDoc.systemHeader) {
                updateDoc.systemHeader = cloneDeep(document.systemHeader);
            }
            // perform any operations specific to a systemType
            DocumentUpdater.performSystemTypeUpdateOperations(document, updateDoc);
            /** @type {?} */
            const updates = yield DocumentUpdater.getUpdates(document, updateDoc);
            yield DocumentUpdater.applyUpdates(document, updates);
        });
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilArray {
    /**
     * @private
     * @param {?} value1
     * @param {?} value2
     * @return {?}
     */
    static defaultComparator(value1, value2) {
        return value1 === value2;
    }
    /**
     * @param {?} array1
     * @param {?} array2
     * @param {?=} comparator
     * @return {?}
     */
    static intersection(array1, array2, comparator) {
        /** @type {?} */
        const temp = [];
        /** @type {?} */
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < array1.length; i++) {
            for (let j = 0; j < array2.length; j++) {
                if (thisComparator(array1[i], array2[j])) {
                    temp.push(array1[i]);
                    break;
                }
            }
        }
        return temp;
    }
    /**
     * @param {?} array1
     * @param {?} array2
     * @param {?=} comparator
     * @return {?}
     */
    static union(array1, array2, comparator) {
        /** @type {?} */
        const temp = array1.concat([]);
        if (!temp || !temp.length) {
            return array2.concat([]);
        }
        /** @type {?} */
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < array2.length; i++) {
            if (!UtilArray.contains(temp, array2[i], thisComparator)) {
                temp.push(array2[i]);
            }
        }
        return temp;
    }
    /**
     * @param {?} sourceArr
     * @param {?} excludedArr
     * @param {?=} comparator
     * @return {?}
     */
    static exclude(sourceArr, excludedArr, comparator) {
        /** @type {?} */
        const temp = [];
        if (!excludedArr || !excludedArr.length) {
            return sourceArr;
        }
        /** @type {?} */
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < sourceArr.length; i++) {
            if (!UtilArray.contains(excludedArr, sourceArr[i], thisComparator)) {
                temp.push(sourceArr[i]);
            }
        }
        return temp;
    }
    /**
     * @param {?} array
     * @param {?} value
     * @param {?=} comparator
     * @return {?}
     */
    static containsIndex(array, value, comparator) {
        if (!array) {
            return -1;
        }
        /** @type {?} */
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < array.length; i++) {
            if (thisComparator(array[i], value)) {
                return i;
            }
        }
        return -1;
    }
    /**
     * @param {?} array
     * @param {?} value
     * @param {?=} comparator
     * @return {?}
     */
    static contains(array, value, comparator) {
        return UtilArray.containsIndex(array, value, comparator) !== -1;
    }
    /**
     * @param {?} arr
     * @param {?} src
     * @param {?} dest
     * @return {?}
     */
    static move(arr, src, dest) {
        arr[dest] = arr[src];
        arr[src] = null;
    }
    /**
     * @param {?} arr
     * @param {?} i
     * @return {?}
     */
    static deleteSplice(arr, i) {
        arr.splice(i, 1);
    }
    /**
     * @param {?} arr
     * @param {?} i
     * @return {?}
     */
    static deleteSetNull(arr, i) {
        arr[i] = null;
    }
    /**
     * @param {?} arr
     * @param {?} i1
     * @param {?} i2
     * @return {?}
     */
    static swap(arr, i1, i2) {
        /** @type {?} */
        const tmp1 = arr[i1];
        arr[i1] = arr[i2];
        arr[i2] = tmp1;
    }
    /**
     * @param {?} array
     * @param {?} item
     * @param {?} excludeDuplicated
     * @param {?=} comparator
     * @return {?}
     */
    static add(array, item, excludeDuplicated, comparator) {
        if (excludeDuplicated && UtilArray.contains(array, item, comparator)) {
            return false;
        }
        array.push(item);
        return true;
    }
    /**
     * @param {?} array
     * @param {?} item
     * @param {?=} comparator
     * @return {?}
     */
    static addOrReplace(array, item, comparator) {
        /** @type {?} */
        const idx = UtilArray.containsIndex(array, item, comparator);
        if (idx !== -1) {
            array[idx] = item;
        }
        else {
            array.push(item);
        }
    }
    /**
     * @param {?} array
     * @param {?} value
     * @param {?=} comparator
     * @return {?}
     */
    static get(array, value, comparator) {
        /** @type {?} */
        const idx = UtilArray.containsIndex(array, value, comparator);
        if (value !== -1) {
            return array[idx];
        }
        return null;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/data/ConflictResolver.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
'use strict';
class ConflictResolver {
    /**
     * @param {?} params
     * @return {?}
     */
    static resolveSimple(params) {
        /** @type {?} */
        const results = (/** @type {?} */ ({}));
        if (!params.newDocumentBaseDoc) {
            results.error = new Error('Base document not provided to ConflictResolver.resolveSimple');
        }
        else if (!params.currentDocument) {
            results.error = new Error('Current Document object not provided to ConflictResolver.resolveSimple');
        }
        else if (!params.newDocument) {
            results.error = new Error('New Document object not provided to ConflictResolver.resolveSimple');
        }
        if (results.error) {
            return results;
        }
        // determine which version is older; let x be older, y newer
        /** @type {?} */
        let x = params.currentDocument;
        /** @type {?} */
        let y = params.newDocument;
        // evaluate which document is most recent.
        /** @type {?} */
        const currentDocCreateTime = new Date(params.currentDocument.systemHeader.createdDate).getTime();
        /** @type {?} */
        const newDocCreateTime = new Date(params.newDocument.systemHeader.createdDate).getTime();
        if (currentDocCreateTime > newDocCreateTime) {
            /** @type {?} */
            const tmp = x;
            x = y;
            y = tmp;
        }
        DocumentUpdater.applyUpdatesSimple(params.newDocumentBaseDoc, x);
        DocumentUpdater.applyUpdatesSimple(params.newDocumentBaseDoc, y);
        /** @type {?} */
        const existedConflictData = params.newDocument.systemHeader.conflicts;
        /** @type {?} */
        const conflictVersions = existedConflictData ? existedConflictData.conflictingVersions : [];
        UtilArray.add(conflictVersions, params.newDocument.systemHeader.versionId, true, null);
        UtilArray.add(conflictVersions, params.currentDocument.systemHeader.versionId, true, null);
        params.newDocumentBaseDoc.systemHeader.conflicts = {
            resolved: false,
            conflictingVersions: conflictVersions
        };
        results.finalDoc = params.newDocumentBaseDoc;
        results.finalDoc.systemHeader.currentVersion = true;
        results.previousVersion = y;
        return results;
    }
    /**
     * @param {?} params
     * @return {?}
     */
    static resolveJSONPatch(params) {
        return __awaiter(this, void 0, void 0, function* () {
            /** @type {?} */
            const results = (/** @type {?} */ ({}));
            if (!params.newDocumentBaseDoc) {
                results.error = new Error('Base document not provided to ConflictResolver.resolveJSONPatch');
            }
            else if (!params.currentDocument) {
                results.error = new Error('Current Document object not provided to ConflictResolver.resolveJSONPatch');
            }
            else if (!params.newDocument) {
                results.error = new Error('New Document object not provided to ConflictResolver.resolveJSONPatch');
            }
            if (results.error) {
                return results;
            }
            // newDocument changes vs newDocumentBaseDoc
            // currentDocument changes vs newDocumentBaseDoc
            /** @type {?} */
            const newDocumentUpdates = params.newUpdates;
            /** @type {?} */
            const currentDocumentUpdates = params.oldUpdates;
            // determine which version is older; let x be older, y newer
            /** @type {?} */
            let x = currentDocumentUpdates;
            /** @type {?} */
            let y = newDocumentUpdates;
            /** @type {?} */
            let recent = params.newDocument;
            // evaluate which document is most recent.
            /** @type {?} */
            const currentDocCreateTime = new Date(params.currentDocument.systemHeader.createdDate).getTime();
            /** @type {?} */
            const newDocCreateTime = new Date(recent.systemHeader.createdDate).getTime();
            if (currentDocCreateTime > newDocCreateTime) {
                x = newDocumentUpdates;
                y = currentDocumentUpdates;
                recent = params.currentDocument;
            }
            yield DocumentUpdater.applyUpdates(params.newDocumentBaseDoc, x);
            yield DocumentUpdater.applyUpdates(params.newDocumentBaseDoc, y);
            /** @type {?} */
            const existedConflictData = params.newDocument.systemHeader.conflicts;
            /** @type {?} */
            const conflictVersions = existedConflictData ? existedConflictData.conflictingVersions : [];
            UtilArray.add(conflictVersions, params.newDocument.systemHeader.versionId, true, null);
            UtilArray.add(conflictVersions, params.currentDocument.systemHeader.versionId, true, null);
            params.newDocumentBaseDoc.systemHeader.conflicts = {
                resolved: false,
                conflictingVersions: conflictVersions
            };
            results.finalDoc = params.newDocumentBaseDoc;
            results.finalDoc.systemHeader.currentVersion = true;
            results.previousVersion = recent;
            return results;
        });
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/ComponentLoader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$1 = console;
/** @type {?} */
const errMsg = 'Error on parsing custom component';
class ComponentLoader {
    /**
     * @param {?} componentDocument
     * @return {?}
     */
    static loadComponent(componentDocument) {
        if (!componentDocument) {
            throw new Error('Component not specified in loadComponent');
        }
        // load the component into an object representing an AngularJS directive. This will be returned as the directive script
        /** @type {?} */
        const directive = (/** @type {?} */ ({}));
        // add each of the standard elements that make up a directive. See the Angular 1 directive documentation for details
        directive.restrict = 'E'; // restrict to element. We are only adding these components as element directives
        directive.require = '?^form';
        directive.scope = {
            tplItem: '=',
            fieldValue: '=',
            fieldName: '=',
            isNew: '=',
            formParameters: '=',
            key: '=',
            doc: '=',
            tpl: '=',
            account: '=',
            responsiveLayouts: '='
        };
        // load the html for the component:
        if (componentDocument.componentHtml) {
            directive.template = componentDocument.componentHtml;
        }
        return JSON.stringify(directive);
    }
    /**
     * @private
     * @param {?} componentDocument
     * @param {?} libraryDocuments
     * @return {?}
     */
    static getLinkFunction(componentDocument, libraryDocuments) {
        /** @type {?} */
        let defFuncStr = 'function(scope, element, attrs, formCtrl){ \n ' +
            'const SharedConstants = SharedConstantsService; \n' +
            'const SearchResultsProcessor = SearchResultsProcessorService; \n' +
            'DirectiveSetupService.setupDirective(scope, formCtrl); \n\n';
        defFuncStr += this.getFieldWatchFunction(componentDocument);
        defFuncStr += this.getCleanupFunction(componentDocument);
        defFuncStr += this.loadLibraryFunctions(libraryDocuments);
        /** @type {?} */
        let linkFunc = ', "link" : ' + defFuncStr + ' \n }';
        /** @type {?} */
        let func = trim(componentDocument.componentLoadFunction);
        if (!isEmpty(func)) {
            try {
                // adding component load function as link function  and replacing load function
                // starting with "function () {"  to include function argument like scope, element,
                // attrs, formCtrl and DirectiveSetupService.setupDirective function to initialise directive.
                func = func.replace(/^(.*function.*){+/, defFuncStr);
                /** @type {?} */
                const loadFunc = Function('return (' + func + ')')();
                linkFunc = ', "link" : ' + loadFunc;
            }
            catch (err) {
                logger$1.error(errMsg + ' load function :' + err);
            }
        }
        return linkFunc;
    }
    /**
     * @private
     * @param {?} componentDocument
     * @return {?}
     */
    static getFieldWatchFunction(componentDocument) {
        /** @type {?} */
        let watchFunc = '';
        /** @type {?} */
        const func = trim(componentDocument.fieldWatchFunction);
        if (!isEmpty(func)) {
            try {
                /** @type {?} */
                const fieldWatchFunction = Function('return (' + func + ')')();
                watchFunc = 'scope.$watch(\'doc["\' + scope.fieldName + \'"]\',' + fieldWatchFunction + ',  true);\n';
            }
            catch (err) {
                logger$1.error(errMsg + ' watch function :' + err);
            }
        }
        return watchFunc;
    }
    /**
     * @private
     * @param {?} componentDocument
     * @return {?}
     */
    static getCleanupFunction(componentDocument) {
        /** @type {?} */
        let destroyFunc = '';
        /** @type {?} */
        const func = trim(componentDocument.componentCleanupFunction);
        if (!isEmpty(func)) {
            try {
                /** @type {?} */
                const cleanupFunc = Function('return (' + func + ')')();
                destroyFunc = 'scope.$on(\'$destroy\',' + cleanupFunc + ');\n';
            }
            catch (err) {
                logger$1.error(errMsg + ' watch function :' + err);
            }
        }
        return destroyFunc;
    }
    /**
     * @private
     * @param {?} libDocs
     * @return {?}
     */
    static loadLibraryFunctions(libDocs) {
        /** @type {?} */
        let libFunctions = '';
        if (!isEmpty(libDocs)) {
            for (let i = 0; i < libDocs.length; i++) {
                /** @type {?} */
                const doc = libDocs[i];
                /** @type {?} */
                const func = doc.componentServiceSnippet;
                try {
                    if (!isEmpty(func)) {
                        libFunctions += 'scope.' + camelCase(doc.serviceName) + ' =' + func + ' \n';
                    }
                }
                catch (err) {
                    logger$1.error(errMsg + ' library document code :' + err);
                }
            }
        }
        return libFunctions;
    }
    /**
     * get the component script for the directive
     * @param {?} componentDocument
     * @param {?} libraryDocuments
     * @return {?}
     */
    static getComponentDirectiveScript(componentDocument, libraryDocuments) {
        /** @type {?} */
        const componentJSON = this.loadComponent(componentDocument);
        /** @type {?} */
        let componentScript;
        if (componentJSON) {
            /** @type {?} */
            const directiveName = camelCase(componentDocument.name);
            componentScript = 'angular.module(\'ft.core\').directive(\'' + directiveName +
                '\',[ \'$compile\', \'DirectiveSetupService\', \'SearchService\',\'$ocLazyLoad\',  ' +
                '\'$injector\',\'$timeout\',\'DataService\', \'$q\', \'SharedConstantsService\', \'SearchResultsProcessorService\', ' +
                'function ($compile, DirectiveSetupService,  SearchService, $ocLazyLoad, $injector, ' +
                '$timeout, DataService, $q, SharedConstantsService, SearchResultsProcessorService) { return ';
            componentScript += componentJSON.substr(0, componentJSON.length - 1);
            componentScript += this.getLinkFunction(componentDocument, libraryDocuments);
            componentScript += '\n }';
            componentScript += '; }]);';
        }
        else {
            throw new Error('Component not found');
        }
        return componentScript;
    }
    /**
     * @param {?} serviceName
     * @param {?} libraryDocuments
     * @return {?}
     */
    static getComponentLibraryServiceScript(serviceName, libraryDocuments) {
        /** @type {?} */
        let componentScript;
        /** @type {?} */
        const getFunctions = (/**
         * @param {?} libDocs
         * @return {?}
         */
        function (libDocs) {
            /** @type {?} */
            let libFunctions = '';
            if (!isEmpty(libDocs)) {
                for (let i = 0; i < libDocs.length; i++) {
                    /** @type {?} */
                    const doc = libDocs[i];
                    /** @type {?} */
                    const func = doc.componentServiceSnippet;
                    try {
                        if (!isEmpty(func)) {
                            if (!isEmpty(libFunctions)) {
                                libFunctions += ',' + ' \n';
                            }
                            libFunctions += func;
                        }
                    }
                    catch (err) {
                        logger$1.error(errMsg + ' library document code :' + err);
                    }
                }
            }
            return libFunctions;
        });
        if (libraryDocuments) {
            serviceName = this.getComponentLibraryScriptServiceName(serviceName);
            componentScript = 'angular.module(\'ft.core\').service(\'' + serviceName +
                '\',[ \'$compile\', \'SearchService\',\'$ocLazyLoad\',  ' +
                '\'$injector\',\'$timeout\',\'DataService\', \'$q\', \'SharedConstantsService\', \'SearchResultsProcessorService\', ' +
                'function ($compile, SearchService, $ocLazyLoad, $injector, ' +
                '$timeout, DataService, $q, SharedConstantsService, SearchResultsProcessorService) { return ';
            componentScript += getFunctions(libraryDocuments);
            componentScript += '\n }';
            componentScript += ' ]);';
        }
        else {
            throw new Error('Component library not found');
        }
        return componentScript;
    }
    /**
     * @param {?} serviceName
     * @return {?}
     */
    static getComponentLibraryScriptServiceName(serviceName) {
        return camelCase(serviceName) + 'Service';
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/versioning/VersionManager.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VersionManager {
    // get initial version, ready to insert
    /**
     * @param {?} document
     * @return {?}
     */
    static createVersion(document) {
        if (document == null || document.documentId == null) {
            return null;
        }
        /** @type {?} */
        const version = cloneDeep(document);
        if (version._id) {
            delete version._id;
        }
        version.systemHeader.currentVersion = false;
        return version;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilError.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$2 = console;
/** @type {?} */
const FORBIDDEN_ERROR = 'ForbiddenError';
/** @type {?} */
const NOT_FOUND_ERROR = 'NotFoundError';
/** @type {?} */
const DELETED_ERROR = 'DeletedError';
/** @type {?} */
const FORBIDDEN_MESSAGE = 'Access Restricted';
/** @type {?} */
const FORBIDDEN_TEMPLATE_MESSAGE = 'Access to the template for this document is restricted and no alternate template ' +
    'is configured. Please configure an alternate template to be able to access this document';
/** @type {?} */
const SERVER_UNRESPONSE_ERROR = 'ServerUnResponseError';
class UtilError {
    /**
     * @param {?} message
     * @param {?=} name
     * @return {?}
     */
    static createError(message, name) {
        logger$2.error(message);
        /** @type {?} */
        const err = new Error(message);
        err.name = name;
        return err;
    }
    /**
     * @param {?} err
     * @return {?}
     */
    static createErrorObject(err) {
        // if the error is a string, create an error object. Otherwise return the error
        if (err instanceof Error) {
            return err;
        }
        else if (typeof err === 'string' || err instanceof String) {
            return new Error(err.toString());
        }
    }
    /**
     * @param {?} doc
     * @param {?} actionType
     * @return {?}
     */
    static createForbiddenError(doc, actionType) {
        /** @type {?} */
        let message;
        if (doc) {
            if (doc.systemHeader &&
                doc.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_TEMPLATE &&
                actionType === SharedConstants.OPERATION_TYPE_READ) {
                message = FORBIDDEN_TEMPLATE_MESSAGE;
            }
            else {
                message = actionType + ' access denied on document ' + doc.documentId;
            }
        }
        return this.createError(message, FORBIDDEN_ERROR);
    }
    /**
     * @param {?} message
     * @return {?}
     */
    static limitErrorMessage(message) {
        if (message && message.length > SharedConstants.DEFAULT_MESSAGE_LENGTH) {
            message = message.substring(0, SharedConstants.DEFAULT_MESSAGE_LENGTH) + '...';
        }
        return message;
    }
}
UtilError.NOT_FOUND_ERROR = NOT_FOUND_ERROR;
UtilError.DELETED_ERROR = DELETED_ERROR;
UtilError.FORBIDDEN_MESSAGE = FORBIDDEN_MESSAGE;
UtilError.FORBIDDEN_TEMPLATE_MESSAGE = FORBIDDEN_TEMPLATE_MESSAGE;
UtilError.FORBIDDEN_ERROR = FORBIDDEN_ERROR;
UtilError.SERVER_UNRESPONSE_ERROR = SERVER_UNRESPONSE_ERROR;
if (false) {
    /** @type {?} */
    UtilError.NOT_FOUND_ERROR;
    /** @type {?} */
    UtilError.DELETED_ERROR;
    /** @type {?} */
    UtilError.FORBIDDEN_MESSAGE;
    /** @type {?} */
    UtilError.FORBIDDEN_TEMPLATE_MESSAGE;
    /** @type {?} */
    UtilError.FORBIDDEN_ERROR;
    /** @type {?} */
    UtilError.SERVER_UNRESPONSE_ERROR;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilApplication.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$3 = console;
/** @type {?} */
const applyApplicationIds = (/**
 * @param {?} document
 * @param {?} template
 * @return {?}
 */
(document, template) => {
    if (template && template.systemHeader && template.systemHeader.applicationIds) {
        document.systemHeader.applicationIds = template.systemHeader.applicationIds;
    }
});
const ɵ0 = applyApplicationIds;
/** @type {?} */
const belongsToApplicationTag = (/**
 * @param {?} doc
 * @param {?} user
 * @return {?}
 */
(doc, user) => {
    return !user.tagApplicationId
        || user.tagApplicationId === doc.systemHeader.tagApplicationId;
});
const ɵ1 = belongsToApplicationTag;
/** @type {?} */
const belongsToApplicationBranch = (/**
 * @param {?} doc
 * @param {?} user
 * @return {?}
 */
(doc, user) => {
    return !user.branchApplicationId ||
        (doc.systemHeader.branchApplicationIds
            && doc.systemHeader.branchApplicationIds.some((/**
             * @param {?} appId
             * @return {?}
             */
            appId => user.branchApplicationId === appId)));
});
const ɵ2 = belongsToApplicationBranch;
/** @type {?} */
const belongsToApplication = (/**
 * @param {?} doc
 * @param {?} user
 * @return {?}
 */
(doc, user) => {
    return !user.applicationId
        || (doc.systemHeader.applicationIds
            && doc.systemHeader.applicationIds.some((/**
             * @param {?} appId
             * @return {?}
             */
            appId => user.applicationId === appId)));
});
const ɵ3 = belongsToApplication;
/** @type {?} */
const checkDocumentApplication = (/**
 * @param {?} doc
 * @param {?} user
 * @return {?}
 */
(doc, user) => {
    if (!belongsToApplication(doc, user)) {
        /** @type {?} */
        let errMessage = `Document ${doc.documentId} doesn't belong to user's selected applicationId: ${user.applicationId}`;
        logger$3.error(errMessage);
        throw UtilError.createForbiddenError(doc, SharedConstants.OPERATION_TYPE_READ);
    }
    if (!belongsToApplicationTag(doc, user)) {
        /** @type {?} */
        let errMessage = `Document ${doc.documentId} doesn't belong to user's selected tagApplicationId: ${user.tagApplicationId}`;
        logger$3.error(errMessage);
        throw UtilError.createForbiddenError(doc, SharedConstants.OPERATION_TYPE_READ);
    }
    if (!belongsToApplicationBranch(doc, user)) {
        /** @type {?} */
        let errMessage = `Document ${doc.documentId} doesn't belong to user's selected branchApplicationId: ${user.applicationId}`;
        logger$3.error(errMessage);
        throw UtilError.createForbiddenError(doc, SharedConstants.OPERATION_TYPE_READ);
    }
});
const ɵ4 = checkDocumentApplication;
/** @type {?} */
const UtilApplication = {
    applyApplicationIds: applyApplicationIds,
    checkDocumentApplication: checkDocumentApplication
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/ESQueryUtils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ESQueryUtils {
    /**
     * @param {?} esQuery
     * @return {?}
     */
    static prepareESQuery(esQuery) {
        if (!esQuery) {
            esQuery = {
                query: {
                    bool: {
                        must: []
                    }
                }
            };
        }
        if (!esQuery.query) {
            esQuery.query = {
                bool: {
                    must: []
                }
            };
        }
        if (!esQuery.query.bool) {
            esQuery.query.bool = {
                must: []
            };
        }
        if (!esQuery.query.bool.must) {
            esQuery.query.bool.must = [];
        }
        return esQuery;
    }
    /**
     * @param {?} esQuery
     * @return {?}
     */
    static stringifyQuery(esQuery) {
        // parse undefined and null values to `undefined`, `null`
        // see details: https://mantis.formbird.com/view.php?id=11986#c48621
        /** @type {?} */
        const result = JSON.stringify(esQuery, (/**
         * @param {?} k
         * @param {?} v
         * @return {?}
         */
        function (k, v) {
            return v == null ? '${v}' : v;
        }));
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/RuleHelper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$4 = console;
class RuleHelper {
    /*
       * Process JSON/Javascript rule set string
       * @document - document object
       * @context - additional objects will be used in rule set script
       * @ruleset - evaluated JSON/Javascript flow
       * @scope - additional scope objects will be plugged in to rule se scope
       */
    /**
     * @param {?} document
     * @param {?} context
     * @param {?} ruleset
     * @param {?} scope
     * @param {?} callback
     * @return {?}
     */
    static processJsonRuleset(document, context, ruleset, scope, callback) {
        try {
            logger$4.debug('In process JSON/Javascript Flow...');
            /** @type {?} */
            const ntf = (/** @type {?} */ ({}));
            ntf.document = document;
            ntf.context = context;
            ntf.user = context.user;
            ntf.logger = context.logger;
            ntf.rsLogger = context.rsLogger;
            ntf.result = { status: null, message: null };
            ntf.scope = scope;
            ntf.runCount = 1;
            ntf.runCountMax = 100;
            ntf.callbackSuccessCompleted = false;
            ntf.documentSession = context.documentSession;
            /** @type {?} */
            const callbackSuccess = (/**
             * @return {?}
             */
            function () {
                if (!ntf.callbackSuccessCompleted) {
                    ntf.callbackSuccessCompleted = true;
                    ntf.result.status = 'SUCCESS';
                    ntf.result.message = null;
                    callback(ntf.result);
                }
                else {
                    /** @type {?} */
                    const msg = 'Multiple callbackSuccess calls detected. Please ensure the ruleset only has one callbackSuccess';
                    callbackError(msg);
                }
            });
            /** @type {?} */
            const callbackError = (/**
             * @param {?} errMsg
             * @return {?}
             */
            function (errMsg) {
                /** @type {?} */
                let name;
                if (errMsg) {
                    if (isError(errMsg)) {
                        errMsg = errMsg.message;
                        name = errMsg.name;
                    }
                }
                ntf.result.status = 'ERROR';
                ntf.result.message = UtilError.limitErrorMessage(errMsg);
                ntf.result.name = name;
                callback(ntf.result);
            });
            // tslint:disable-next-line:no-shadowed-variable
            /** @type {?} */
            const callbackContinue = (/**
             * @param {?} ntf
             * @return {?}
             */
            function (ntf) {
                // Check if looped too much
                ntf.runCount += 1;
                if (ntf.runCount > ntf.runCountMax) {
                    callbackError('Run Count exceeded -- check there is not a self-looping issue in your script.');
                }
                else {
                    logger$4.info('Re-executing ruleset in callbackContinue with count: ' + ntf.runCount);
                    ruleset.mainRule(ntf, callbackContinue, callbackSuccess, callbackError);
                }
            });
            // In Main Rule
            ruleset.mainRule(ntf, callbackContinue, callbackSuccess, callbackError);
        }
        catch (e) {
            /** @type {?} */
            let msg = 'Errors in JSON/Javascript ruleset: ';
            if (isError(e)) {
                msg += e.name + ' : ' + e.message;
            }
            else {
                msg += e;
            }
            logger$4.error(msg);
            if (scope.rsLogger) {
                scope.rsLogger.error(msg);
                scope.rsLogger.storeMessages();
            }
            callback({
                status: 'ERROR',
                message: UtilError.limitErrorMessage(msg)
            });
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/SearchResultsProcessor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$5 = console;
class SearchResultsProcessor {
    /**
     * process search results asynchronously in parallel. This should be used when processing order is not important
     * @param {?} results
     * @param {?} elementProcessingCallback
     * @param {?} completionCallback
     * @return {?}
     */
    static processSearchResultsParallel(results, elementProcessingCallback, completionCallback) {
        SearchResultsProcessor.process(each, results, elementProcessingCallback, completionCallback);
    }
    /**
     * process search results asynchronously in series. This should be used when processing order is important
     * @param {?} results
     * @param {?} elementProcessingCallback
     * @param {?} completionCallback
     * @return {?}
     */
    static processSearchResults(results, elementProcessingCallback, completionCallback) {
        SearchResultsProcessor.process(eachSeries, results, elementProcessingCallback, completionCallback);
    }
    /**
     *
     * @param {?} processingFunction - the function from the async package that will be used to process the results
     * @param {?} results
     * @param {?} elementProcessingCallback
     * @param {?} completionCallback
     * @return {?}
     */
    static process(processingFunction, results, elementProcessingCallback, completionCallback) {
        /** @type {?} */
        const docs = [];
        /** @type {?} */
        const isOtherSearch = (results.searchProvier && results.searchProvier !== 'elastic');
        /** @type {?} */
        let resultDocs;
        /** @type {?} */
        let totalHits = 0;
        if (isOtherSearch) {
            resultDocs = results.data;
            totalHits = results.total ? results.total : results.data.length;
        }
        else {
            resultDocs = results.data.hits.hits;
            totalHits = results.data.hits.total;
        }
        processingFunction(resultDocs, (/**
         * @param {?} hit
         * @param {?} next
         * @return {?}
         */
        function (hit, next) {
            /** @type {?} */
            let doc;
            if (isOtherSearch) {
                // if alias is not given in the select statement, then the result enclosed with bucketName / db Name.
                /** @type {?} */
                const objKeys = Object.keys(hit);
                if (objKeys.length <= 1 && results.dbName === objKeys[0]) {
                    delete hit[objKeys[0]].total_hits;
                    doc = hit[objKeys[0]];
                }
                else {
                    delete hit.total_hits;
                    doc = hit;
                }
            }
            else {
                doc = hit._source;
            }
            elementProcessingCallback(doc);
            docs.push(doc);
            next();
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            if (err) {
                logger$5.error('Error in processing search results : ' + JSON.stringify(err));
            }
            completionCallback(docs, totalHits);
        }));
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/DocumentIdValidator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DocumentIdValidator {
    /**
     * @param {?} documentId
     * @param {?} documentIdRules
     * @return {?}
     */
    static validateDocumentId(documentId, documentIdRules) {
        /** @type {?} */
        const alphaNumeric = /^[0-9a-zA-Z-]+$/;
        if (!documentIdRules) {
            documentIdRules = {};
        }
        if (!documentIdRules.minimumLength) {
            documentIdRules.minimumLength = 24; // default to 24, the length of an ObjectId
        }
        /** @type {?} */
        const result = {
            valid: true,
            reason: documentId + ' documentId is valid.'
        };
        if (!documentId) {
            result.valid = false;
            result.reason = 'Unable to validate undefined documentId.';
        }
        else if (typeof documentId !== 'string') {
            result.valid = false;
            result.reason = 'DocumentId should be a string.';
        }
        else if (!documentId.match(alphaNumeric)) {
            result.valid = false;
            result.reason = 'DocumentId should consist of alphanumeric characters.';
        }
        else if (documentIdRules.minimumLength > documentId.length) {
            result.valid = false;
            result.reason = 'DocumentId should have a minimum length of ' + documentIdRules.minimumLength + '.';
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilString {
    /**
     * @param {?} path
     * @param {?} separator
     * @return {?}
     */
    static convertToObjectPathArray(path, separator) {
        if (!path) {
            return '';
        }
        if (!separator) {
            separator = '/';
        }
        if (path.indexOf(separator) === 0) {
            path = path.substring(1);
        }
        return path.split(separator);
    }
    /**
     * @param {?} string
     * @return {?}
     */
    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    /**
     * @param {?} strings
     * @param {?} string
     * @return {?}
     */
    static arrayInString(strings, string) {
        /** @type {?} */
        let i = 0;
        /** @type {?} */
        let inString = false;
        do {
            inString = string.indexOf(strings[i++]) !== -1;
        } while (!inString && i < strings.length);
        return inString;
    }
    /**
     * @param {?} path
     * @param {?=} separator
     * @return {?}
     */
    static convertToObjectPath(path, separator) {
        /** @type {?} */
        const result = this.convertToObjectPathArray(path, separator).join('.');
        return result;
    }
    /**
     * @param {?} text
     * @return {?}
     */
    static escapeSpecialChar(text) {
        /** @type {?} */
        const rexp = /[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi;
        return text.replace(rexp, '\\$&');
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilConflict.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilConflict {
    /**
     * @param {?} currentDocument
     * @param {?} remoteDocument
     * @return {?}
     */
    static getDiffs(currentDocument, remoteDocument) {
        /** @type {?} */
        const diffs = [];
        /** @type {?} */
        const remoteKeys = Object.keys(remoteDocument);
        /** @type {?} */
        const currentKeys = Object.keys(currentDocument);
        /** @type {?} */
        const unionKeys = UtilArray.union(remoteKeys, currentKeys);
        for (let k = 0; k < unionKeys.length; k++) {
            /** @type {?} */
            const key = unionKeys[k];
            if (key !== 'systemHeader') {
                /** @type {?} */
                const currentValue = JSON.stringify(currentDocument[key]);
                /** @type {?} */
                const remoteValue = JSON.stringify(remoteDocument[key]);
                if (currentValue !== remoteValue) { // compare as string
                    diffs.push({
                        fieldName: key,
                        currentValue: currentDocument[key],
                        remoteValue: remoteDocument[key]
                    });
                }
            }
        }
        return diffs;
    }
    /**
     * @param {?} newUpdatesData
     * @param {?} oldUpdatesData
     * @return {?}
     */
    static checkConflict(newUpdatesData, oldUpdatesData) {
        if (newUpdatesData && newUpdatesData.updates && oldUpdatesData && oldUpdatesData.updates) {
            for (let i = newUpdatesData.updates.length - 1; i >= 0; i--) {
                /** @type {?} */
                const change = newUpdatesData.updates[i];
                /** @type {?} */
                const path = UtilString.convertToObjectPath(change.path);
                if (path.indexOf('systemHeader') !== 0) { // exclude systemHeader checking
                    for (let j = oldUpdatesData.updates.length - 1; j >= 0; j--) {
                        /** @type {?} */
                        const jChange = oldUpdatesData.updates[j];
                        /** @type {?} */
                        const jPath = UtilString.convertToObjectPath(jChange.path, '/');
                        if (path === jPath) { // Old and new updates on the same field ==> conflict
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilCSV.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilCSV {
    /**
     * @param {?} dataObject
     * @param {?} columnsLabels
     * @return {?}
     */
    static validateColumnHeader(dataObject, columnsLabels) {
        /** @type {?} */
        let isHeader = true;
        if (dataObject.length > 0 && columnsLabels && dataObject[0].length === columnsLabels.length) {
            for (let i = 0; i < dataObject[0].length; i++) {
                if (dataObject[0][i] !== columnsLabels[i]) {
                    isHeader = false;
                    break;
                }
            }
        }
        else {
            isHeader = false;
        }
        return isHeader;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilType.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilType {
    /**
     * @param {?} val
     * @return {?}
     */
    static hasValue(val) {
        if (val === false || val === 0) {
            return true;
        }
        else if (!val) {
            return false;
        }
        /** @type {?} */
        const condition1 = val.length !== 0;
        /** @type {?} */
        const condition2 = typeof (val) === 'object' && Object.keys(val).length !== 0;
        return condition1 || condition2;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    static isDefined(val) {
        return val !== null && typeof (val) !== 'undefined';
    }
    /**
     * @param {?} val
     * @return {?}
     */
    static isString(val) {
        return (typeof val === 'string' || val instanceof String);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilDocument.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilDocument {
    /**
     * @param {?} doc
     * @return {?}
     */
    static isNew(doc) {
        return !doc.systemHeader || !doc.systemHeader.createdDate;
    }
    /**
     * @param {?} doc
     * @return {?}
     */
    static isPreviousVersion(doc) {
        return doc.systemHeader && doc.systemHeader.currentVersion === false;
    }
    /**
     * @param {?} doc
     * @return {?}
     */
    static isDeleted(doc) {
        /** @type {?} */
        const deleted = doc.systemHeader ? doc.systemHeader.deleted : false;
        return deleted === true || deleted === 'true';
    }
    /**
     * @param {?} srcObj
     * @param {?} targetObj
     * @return {?}
     */
    static hasIntersect(srcObj, targetObj) {
        if (!srcObj || !targetObj) {
            return false;
        }
        /** @type {?} */
        const keys = Object.keys(targetObj);
        for (let i = 0; i < keys.length; i++) {
            /** @type {?} */
            const key = keys[i];
            if (UtilType.isDefined(srcObj[key]) &&
                UtilType.isDefined(targetObj[key]) &&
                srcObj[key] === targetObj[key]) {
                return true;
            }
        }
        return false;
    }
    ;
    /**
     * @param {?} doc
     * @param {?} targetFieldNames
     * @return {?}
     */
    static filterDocumentFields(doc, targetFieldNames) {
        if (!targetFieldNames || targetFieldNames.length === 0) {
            return doc;
        }
        /** @type {?} */
        const result = {};
        targetFieldNames.forEach((/**
         * @param {?} fieldName
         * @return {?}
         */
        function (fieldName) {
            /** @type {?} */
            const val = get(doc, fieldName);
            set(result, fieldName, val);
        }));
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilDocumentId.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const UUID_LENGTH = 36;
class UtilDocumentId {
    /**
     * @return {?}
     */
    static generateId() {
        // use a v1 id. This includes the device hardware in the generation, so there is more chance of uniqueness
        return v1();
    }
    /**
     * @param {?} id
     * @return {?}
     */
    static isValid(id) {
        // start with an initial test of checking that the length is correct
        return id && id.length === UUID_LENGTH;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilGeoJSON.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilGeoJSON {
    /**
     * @private
     * @param {?} val
     * @return {?}
     */
    static hasValue(val) {
        /** @type {?} */
        let found = false;
        if (isArray(val)) {
            for (let i = 0; i < val.length; i++) {
                if (val[i]) {
                    found = true;
                }
            }
        }
        else if (val) {
            found = true;
        }
        return found;
    }
    /*
       check whether the geojson has any values. This currently only works with basic addresses with coordinates and properties. It will
       need to be improved to work with more complex geojson structures like polygons
       */
    /**
     * @param {?} value
     * @return {?}
     */
    static hasValues(value) {
        /** @type {?} */
        let found = false;
        if (value && value.features) {
            /** @type {?} */
            const features = value.features;
            for (let i = 0; i < features.length && !found; i++) {
                // ignore the type parameter, because a type alone isn't enough to say there is a value
                // check the properties
                if (features[i].properties) {
                    for (const key in features[i].properties) {
                        if (features[i].properties.hasOwnProperty(key)) {
                            if (features[i].properties[key]) {
                                found = this.hasValue(features[i].properties[key]);
                                if (found) {
                                    break;
                                }
                            }
                        }
                    }
                }
                // check the geometry
                if (!found && features[i].geometry && features[i].geometry.coordinates) {
                    for (let j = 0; j < features[i].geometry.coordinates.length; j++) {
                        if (features[i].geometry.coordinates[j]) {
                            if (isString(features[i].geometry.coordinates[j])) {
                                if (trim(features[i].geometry.coordinates[j]) !== '') {
                                    found = true;
                                    break;
                                }
                            }
                            else {
                                found = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
        return found;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilHttpStatus.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Constants enumerating the HTTP status codes.
 *
 * All status codes defined in RFC1945 (HTTP/1.0, RFC2616 (HTTP/1.1),
 * and RFC2518 (WebDAV) are supported.
 *
 * Based on the org.apache.commons.httpclient.HttpStatus Java API.
 *
 * Ported by Bryce Neal.
 */
/** @type {?} */
const UtilHttpStatus = (/** @type {?} */ ({
    ACCEPTED: 202,
    BAD_GATEWAY: 502,
    BAD_REQUEST: 400,
    CONFLICT: 409,
    CONTINUE: 100,
    CREATED: 201,
    EXPECTATION_FAILED: 417,
    FORBIDDEN: 403,
    GATEWAY_TIMEOUT: 504,
    GONE: 410,
    HTTP_VERSION_NOT_SUPPORTED: 505,
    INSUFFICIENT_SPACE_ON_RESOURCE: 419,
    INSUFFICIENT_STORAGE: 507,
    INTERNAL_SERVER_ERROR: 500,
    LENGTH_REQUIRED: 411,
    LOCKED: 423,
    METHOD_FAILURE: 420,
    METHOD_NOT_ALLOWED: 405,
    MOVED_PERMANENTLY: 301,
    MOVED_TEMPORARILY: 302,
    MULTI_STATUS: 207,
    MULTIPLE_CHOICES: 300,
    NO_CONTENT: 204,
    NON_AUTHORITATIVE_INFORMATION: 203,
    NOT_ACCEPTABLE: 406,
    NOT_FOUND: 404,
    NOT_IMPLEMENTED: 501,
    NOT_MODIFIED: 304,
    OK: 200,
    PARTIAL_CONTENT: 206,
    PAYMENT_REQUIRED: 402,
    PRECONDITION_FAILED: 412,
    PROCESSING: 102,
    PROXY_AUTHENTICATION_REQUIRED: 407,
    REQUEST_TIMEOUT: 408,
    REQUEST_TOO_LONG: 413,
    REQUEST_URI_TOO_LONG: 414,
    REQUESTED_RANGE_NOT_SATISFIABLE: 416,
    RESET_CONTENT: 205,
    SEE_OTHER: 303,
    SERVICE_UNAVAILABLE: 503,
    SWITCHING_PROTOCOLS: 101,
    TEMPORARY_REDIRECT: 307,
    UNAUTHORIZED: 401,
    UNPROCESSABLE_ENTITY: 422,
    UNSUPPORTED_MEDIA_TYPE: 415,
    USE_PROXY: 305,
    ELASTICSEARCH: 306,
    SERVER_UNRESPONSIVE: 0
}));
/** @type {?} */
const statusCodes = {};
statusCodes[UtilHttpStatus.ACCEPTED] = 'Accepted';
statusCodes[UtilHttpStatus.BAD_GATEWAY] = 'Bad Gateway';
statusCodes[UtilHttpStatus.BAD_REQUEST] = 'Bad Request';
statusCodes[UtilHttpStatus.CONFLICT] = 'Conflict';
statusCodes[UtilHttpStatus.CONTINUE] = 'Continue';
statusCodes[UtilHttpStatus.CREATED] = 'Created';
statusCodes[UtilHttpStatus.EXPECTATION_FAILED] = 'Expectation Failed';
statusCodes[UtilHttpStatus.FORBIDDEN] = 'Forbidden';
statusCodes[UtilHttpStatus.GATEWAY_TIMEOUT] = 'Gateway Timeout';
statusCodes[UtilHttpStatus.GONE] = 'Gone';
statusCodes[UtilHttpStatus.HTTP_VERSION_NOT_SUPPORTED] = 'HTTP Version Not Supported';
statusCodes[UtilHttpStatus.INSUFFICIENT_SPACE_ON_RESOURCE] = 'Insufficient Space on Resource';
statusCodes[UtilHttpStatus.INSUFFICIENT_STORAGE] = 'Insufficient Storage';
statusCodes[UtilHttpStatus.INTERNAL_SERVER_ERROR] = 'Server Error';
statusCodes[UtilHttpStatus.LENGTH_REQUIRED] = 'Length Required';
statusCodes[UtilHttpStatus.LOCKED] = 'Locked';
statusCodes[UtilHttpStatus.METHOD_FAILURE] = 'Method Failure';
statusCodes[UtilHttpStatus.METHOD_NOT_ALLOWED] = 'Method Not Allowed';
statusCodes[UtilHttpStatus.MOVED_PERMANENTLY] = 'Moved Permanently';
statusCodes[UtilHttpStatus.MOVED_TEMPORARILY] = 'Moved Temporarily';
statusCodes[UtilHttpStatus.MULTI_STATUS] = 'Multi-Status';
statusCodes[UtilHttpStatus.MULTIPLE_CHOICES] = 'Multiple Choices';
statusCodes[UtilHttpStatus.NO_CONTENT] = 'No Content';
statusCodes[UtilHttpStatus.NON_AUTHORITATIVE_INFORMATION] = 'Non Authoritative Information';
statusCodes[UtilHttpStatus.NOT_ACCEPTABLE] = 'Not Acceptable';
statusCodes[UtilHttpStatus.NOT_FOUND] = 'Not Found';
statusCodes[UtilHttpStatus.NOT_IMPLEMENTED] = 'Not Implemented';
statusCodes[UtilHttpStatus.NOT_MODIFIED] = 'Not Modified';
statusCodes[UtilHttpStatus.OK] = 'OK';
statusCodes[UtilHttpStatus.PARTIAL_CONTENT] = 'Partial Content';
statusCodes[UtilHttpStatus.PAYMENT_REQUIRED] = 'Payment Required';
statusCodes[UtilHttpStatus.PRECONDITION_FAILED] = 'Precondition Failed';
statusCodes[UtilHttpStatus.PROCESSING] = 'Processing';
statusCodes[UtilHttpStatus.PROXY_AUTHENTICATION_REQUIRED] = 'Proxy Authentication Required';
statusCodes[UtilHttpStatus.REQUEST_TIMEOUT] = 'Request Timeout';
statusCodes[UtilHttpStatus.REQUEST_TOO_LONG] = 'Request Entity Too Large';
statusCodes[UtilHttpStatus.REQUEST_URI_TOO_LONG] = 'Request-URI Too Long';
statusCodes[UtilHttpStatus.REQUESTED_RANGE_NOT_SATISFIABLE] = 'Requested Range Not Satisfiable';
statusCodes[UtilHttpStatus.RESET_CONTENT] = 'Reset Content';
statusCodes[UtilHttpStatus.SEE_OTHER] = 'See Other';
statusCodes[UtilHttpStatus.SERVICE_UNAVAILABLE] = 'Service Unavailable';
statusCodes[UtilHttpStatus.SWITCHING_PROTOCOLS] = 'Switching Protocols';
statusCodes[UtilHttpStatus.TEMPORARY_REDIRECT] = 'Temporary Redirect';
statusCodes[UtilHttpStatus.UNAUTHORIZED] = 'Unauthorized';
statusCodes[UtilHttpStatus.UNPROCESSABLE_ENTITY] = 'Unprocessable Entity';
statusCodes[UtilHttpStatus.UNSUPPORTED_MEDIA_TYPE] = 'Unsupported Media Type';
statusCodes[UtilHttpStatus.USE_PROXY] = 'Use Proxy';
statusCodes[UtilHttpStatus.ELASTICSEARCH] = 'Error - search is not running. Please contact a system administrator to configure it';
statusCodes[UtilHttpStatus.SERVER_UNRESPONSIVE] = 'Aborted/Timed out request: Server is down or client not connected.';
/**
 * @param {?} statusCode
 * @return {?}
 */
function getStatusText(statusCode) {
    if (statusCodes.hasOwnProperty(statusCode)) {
        return statusCodes[statusCode];
    }
    else {
        throw new Error('Status code does not exist: ' + statusCode);
    }
}
UtilHttpStatus.getStatusText = getStatusText;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilIncludeRuleSet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} includeNames
 * @return {?}
 */
function filterDuplicates(includeNames) {
    /** @type {?} */
    const filtered = [];
    for (let i = 0; i < includeNames.length; i++) {
        /** @type {?} */
        const includeName = includeNames[i];
        if (!UtilArray.contains(filtered, includeName)) {
            filtered.push(includeName);
        }
    }
    return filtered;
}
/**
 * @param {?} ruleFlow
 * @return {?}
 */
function getIncludeNames(ruleFlow) {
    if (ruleFlow) {
        /** @type {?} */
        const includeNames = [];
        /** @type {?} */
        const exp = /[\t ]*[\#]include\s+\".*\"/mg;
        /** @type {?} */
        let syntax;
        while ((syntax = exp.exec(ruleFlow)) !== null) {
            if (syntax) {
                /** @type {?} */
                const exp2 = new RegExp('[\'\"](.*)[\'\"]');
                /** @type {?} */
                const includeName = exp2.exec(syntax)[1];
                includeNames.push(includeName);
            }
        }
        return includeNames;
    }
    return [];
}
class UtilIncludeRuleSet {
    /**
     * @param {?} ruleFlow
     * @return {?}
     */
    static getIncludeNames(ruleFlow) {
        /** @type {?} */
        const includeNames = getIncludeNames(ruleFlow);
        return [].concat(filterDuplicates(includeNames));
    }
    /**
     * @param {?} ruleFlow
     * @return {?}
     */
    static getDuplicateIncludes(ruleFlow) {
        /** @type {?} */
        const includeNames = getIncludeNames(ruleFlow);
        /** @type {?} */
        const filtered = [];
        for (let i = 0; i < includeNames.length; i++) {
            /** @type {?} */
            const includeName = includeNames[i];
            if (!UtilArray.contains(filtered, includeName)) {
                filtered.push(includeName);
            }
            else {
                return includeName;
            }
        }
        return null;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilRules.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilRules {
    /**
     * @param {?} eventName
     * @return {?}
     */
    static getRelatedName(eventName) {
        /** @type {?} */
        const ruleConstants = SharedConstants.RULESET_RELATIONSHIPS;
        /** @type {?} */
        const keys = Object.keys(ruleConstants);
        /** @type {?} */
        let relName;
        for (let i = 0; i < keys.length; i++) {
            if (ruleConstants[keys[i]].name === eventName) {
                relName = ruleConstants[keys[i]].relName;
                break;
            }
        }
        return relName;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/RulesError.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ExtendableError extends Error {
    /**
     * @param {?} message
     */
    constructor(message) {
        super();
        this.message = message;
        this.stack = (new Error()).stack;
        this.name = this.constructor.name;
    }
}
class RulesetError extends ExtendableError {
    /**
     * @param {?} m
     */
    constructor(m) {
        super(m);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilSystemHeader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const logger$6 = console;
class UtilSystemHeader {
    /**
     * @param {?} doc
     * @param {?} handlebarsSource
     * @return {?}
     */
    static writeSystemHeaderValue(doc, handlebarsSource) {
        /** @type {?} */
        let result;
        if (handlebarsSource && doc) {
            /** @type {?} */
            const hbTemplate = compile(handlebarsSource);
            result = hbTemplate(doc);
        }
        return result;
    }
    /**
     * @param {?} newRecord
     * @param {?} template
     * @param {?} oldRecord
     * @param {?=} updates
     * @return {?}
     */
    static writeSystemHeaderSummary(newRecord, template, oldRecord, updates) {
        logger$6.debug('Writing system header summary');
        if (template) {
            /** @type {?} */
            let nameSource;
            /** @type {?} */
            let descriptionSource;
            if (template.summaryNameRule || template.summaryDescriptionRule) {
                nameSource = template.summaryNameRule;
                descriptionSource = template.summaryDescriptionRule;
                if (newRecord) {
                    /** @type {?} */
                    let hbDocument;
                    if (oldRecord) {
                        hbDocument = cloneDeep(oldRecord);
                        // applying updates for Handlebars compiling purpose only
                        /** @type {?} */
                        const keys = Object.keys(newRecord);
                        for (let i = 0; i < keys.length; i++) {
                            /** @type {?} */
                            const key = keys[i];
                            hbDocument[key] = newRecord[key];
                        }
                    }
                    else {
                        hbDocument = cloneDeep(newRecord);
                    }
                    /** @type {?} */
                    let hbTemplate;
                    if (nameSource) {
                        hbTemplate = compile(nameSource);
                        if (updates && updates.systemHeader && updates.systemHeader.summaryName) {
                            newRecord.systemHeader.summaryName = updates.systemHeader.summaryName;
                        }
                        else {
                            newRecord.systemHeader.summaryName = hbTemplate(hbDocument);
                        }
                    }
                    if (descriptionSource) {
                        hbTemplate = compile(descriptionSource);
                        if (updates && updates.systemHeader && updates.systemHeader.summaryDescription) {
                            newRecord.systemHeader.summaryDescription = updates.systemHeader.summaryDescription;
                        }
                        else {
                            newRecord.systemHeader.summaryDescription = hbTemplate(hbDocument);
                        }
                    }
                }
            }
        }
    }
    /**
     * @param {?} newRecord
     * @param {?} operationType
     * @param {?} user
     * @param {?} now
     * @return {?}
     */
    static writeSystemHeaderCreated(newRecord, operationType, user, now) {
        // Write on insert and update.
        // The created fields represent when and who created this version of the document.
        if (operationType === SharedConstants.INSERT_OPERATION_TYPE
            || operationType === SharedConstants.UPDATE_OPERATION_TYPE) {
            if (!newRecord.systemHeader.createdDate) {
                newRecord.systemHeader.createdDate = (now ? now : new Date());
            }
            if (user) {
                newRecord.systemHeader.createdBy = user.documentId;
            }
        }
        if (operationType === SharedConstants.INSERT_OPERATION_TYPE) {
            if (!newRecord.systemHeader.documentCreatedDate) {
                newRecord.systemHeader.documentCreatedDate = (now ? now : new Date());
            }
            if (user && !newRecord.systemHeader.documentCreatedBy) {
                newRecord.systemHeader.documentCreatedBy = user.documentId;
            }
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilUploads.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const EX_CONSTANTS = {
    'documentExtensionNameMap': {
        'DOC': 'Word 97-2003 Document',
        'DOCX': 'Word Document',
        'PPT': 'PowerPoint 97-2003 Presentation',
        'PPTX': 'PowerPoint Presentation',
        'XLS': 'Excel 97-2003 Workbook',
        'XLSX': 'Excel Workbook'
    },
    'supportedImageExtensions': [
        'png',
        'jpg',
        'jpeg',
        'gif',
        'tif',
        'tiff',
        'bmp',
        'png',
        'psd',
        'psp',
        'svg'
    ],
    'supportedVideoExtensions': [
        'ogg',
        'mp4',
        'webm'
    ]
};
class UtilUploads {
    /**
     * Looks for the needle in the array haystack and returns the index
     * @private
     * @param {?} needle the needle
     * @param {?} arrHayStack the arrHayStack
     * @return {?} The index of needle in arrHayStack else -1
     */
    static getItemIndex(needle, arrHayStack) {
        return arrHayStack.indexOf(needle);
    }
    /**
     * Checks if file is an image.
     * @param {?} fileName the provided file name
     * @return {?} boolean the result
     */
    static isImageFile(fileName) {
        /** @type {?} */
        const ext = UtilUploads.getExtension(fileName).toLowerCase();
        return UtilUploads.filterImage(ext);
    }
    /**
     * Given a file name, returns the extension in uppercase
     * @param {?} fileName the file name
     * @return {?} string the result
     */
    static getExtension(fileName) {
        /** @type {?} */
        const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
        return ext.toUpperCase();
    }
    /**
     * Returns true if the extension is an image
     * @param {?} ext extension
     * @return {?} boolean the result
     */
    static filterImage(ext) {
        /** @type {?} */
        const result = UtilUploads.arrayContains(ext.toLowerCase(), EX_CONSTANTS.supportedImageExtensions);
        return result;
    }
    /**
     * Looks for the needle in the array haystack
     * @param {?} needle the needle
     * @param {?} arrHayStack the arrHayStack
     * @return {?} boolean the result
     */
    static arrayContains(needle, arrHayStack) {
        return UtilUploads.getItemIndex(needle, arrHayStack) > -1;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilValidation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilValidation {
    /**
     * @param {?} dataFields
     * @return {?}
     */
    static getValidatorObj(dataFields) {
        /** @type {?} */
        const validationObj = (/** @type {?} */ ({}));
        if (UtilValidation.hasValue(dataFields) && dataFields.fieldValidator &&
            dataFields.fieldValidator.validationFunc && dataFields.fieldValidator.validationMsg) {
            // disable warning about use of Function. This is because using dynamically loaded code isn't seen as a good thing.
            // we're doing it to load the code from the template but wouldn't do it for normal file scripts
            /* jshint -W054 */
            validationObj.validationFunc = new Function('value', dataFields.fieldValidator.validationFunc);
            /* jshint +W054 */
            validationObj.validationMsg = dataFields.fieldValidator.validationMsg;
            validationObj.name = dataFields.fieldValidator.name;
        }
        return validationObj;
    }
    /**
     * @param {?} field
     * @return {?}
     */
    static hasValidateFunc(field) {
        /** @type {?} */
        const validateObj = UtilValidation.getValidatorObj(field);
        return validateObj.validationFunc ? true : false;
    }
    /**
     * @param {?} field
     * @return {?}
     */
    static validateFieldValue(field) {
        /** @type {?} */
        let res = false;
        /** @type {?} */
        const validateObj = UtilValidation.getValidatorObj(field);
        if (validateObj.validationFunc && field.fieldValue) {
            /** @type {?} */
            const validatorFunc = validateObj.validationFunc;
            res = validatorFunc(field.fieldValue);
        }
        return res;
    }
    /*
       * Validate field value, if the validation get errors, the validator name will be returned. Otherwise, return null.
       */
    /**
     * @param {?} validator
     * @param {?} newValue
     * @return {?}
     */
    static validateField(validator, newValue) {
        /** @type {?} */
        let res = true;
        if (validator.validationFunc) {
            /** @type {?} */
            const validatorFunc = validator.validationFunc;
            res = validatorFunc(newValue);
        }
        return res === false ? validator.name : null;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    static hasValue(val) {
        return val !== null && typeof (val) !== 'undefined' && val !== '';
    }
    /**
     * @param {?} val
     * @param {?} minLength
     * @return {?}
     */
    static validateMinLength(val, minLength) {
        return UtilValidation.hasValue(val) && val.length >= minLength;
    }
    /**
     * @param {?} val
     * @param {?} maxLength
     * @return {?}
     */
    static validateMaxLength(val, maxLength) {
        return !val || UtilValidation.hasValue(val) && val.length <= maxLength;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilSequenceProcess.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtilSequenceProcess {
    /**
     * @param {?} list
     * @param {?} asyncJob
     * @return {?}
     */
    static processList(list, asyncJob) {
        /** @type {?} */
        let sequence = Promise.resolve();
        list.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            sequence = sequence.then((/**
             * @return {?}
             */
            function () {
                return asyncJob(item);
            }));
        }));
        return sequence;
    }
    /**
     * @param {?} startIndex
     * @param {?} endIndex
     * @param {?} asyncJob
     * @return {?}
     */
    static processRange(startIndex, endIndex, asyncJob) {
        /** @type {?} */
        let sequence = Promise.resolve();
        for (let i = startIndex; i <= endIndex; i++) {
            sequence = sequence.then((/**
             * @return {?}
             */
            function () {
                return asyncJob(i);
            }));
        }
        return sequence;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/utils/UtilHandlebars.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$1 = /**
 * @param {?} Handlebars
 * @return {?}
 */
(Handlebars) => {
    Handlebars.registerHelper({
        eq: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 === v2;
        }),
        ne: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 !== v2;
        }),
        lt: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 < v2;
        }),
        gt: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 > v2;
        }),
        lte: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 <= v2;
        }),
        gte: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 >= v2;
        }),
        and: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 && v2;
        }),
        or: (/**
         * @param {?} v1
         * @param {?} v2
         * @return {?}
         */
        function (v1, v2) {
            return v1 || v2;
        })
    });
};
/** @type {?} */
const UtilHandleBars = {
    registerHelper: (ɵ0$1)
};

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: formbird-shared.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AccessManager, ComponentLoader, ConflictResolver, DocumentIdValidator, DocumentUpdater, ESQueryUtils, ErrorCodes, FormbirdSharedModule, RuleHelper, RulesetError, SearchResultsProcessor, SharedUrlRoutes, SystemHeaderFilter, UtilApplication, UtilArray, UtilCSV, UtilConflict, UtilDocument, UtilDocumentId, UtilError, UtilGeoJSON, UtilHandleBars, UtilHttpStatus, UtilIncludeRuleSet, UtilRules, UtilSequenceProcess, UtilString, UtilSystemHeader, UtilType, UtilUploads, UtilValidation, VersionManager };
//# sourceMappingURL=formbird-shared.js.map
